// extracted by mini-css-extract-plugin
export default {"div1":"wishlist_div1__3udOb","p1":"wishlist_p1__ZTKbY","div2":"wishlist_div2__Ne5L0","alert":"wishlist_alert__Ty72i","loader":"wishlist_loader__4r+XF"};